import styled from "styled-components"

import { ReactComponent as IconMagnifyingGlass } from "assets/svg/icon-magnifying-glass.svg"

const Wrap = styled.div`
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 8px;
`

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  border-radius: 72px;
  background: var(--accent-subtle);
  color: var(--text-primary);

  svg {
    width: 24px;
    height: 24px;
  }
`

const Title = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--text-secondary);
`

const Subtitle = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.176px;
  color: var(--text-secondary);
`

interface Props {
  title: string
  description?: string
}

export function EmptyState({ title, description }: Props) {
  return (
    <Wrap>
      <IconWrap>
        <IconMagnifyingGlass aria-hidden />
      </IconWrap>
      <Title>{title}</Title>
      {description && <Subtitle>{description}</Subtitle>}
    </Wrap>
  )
}
